<template>
  <tr>
    <td>{{ application.id }}</td>

    <td v-if="editRow" class="text-center">
      <input
        v-model="editFormAppKey"
        type="text"
        :class="{ 'is-invalid': formErrors['appKey'] }"
        class="form-control form-control-sm"
      />
    </td>
    <td v-else>{{ application.appKey || "" }}</td>

    <td v-if="editRow" class="text-center">
      <input
        v-model="editFormDbHost"
        type="text"
        class="form-control form-control-sm"
      />
    </td>
    <td v-else>{{ application.dbHost || "" }}</td>

    <td v-if="editRow" class="text-center">
      <input
        v-model="editFormDbName"
        type="text"
        class="form-control form-control-sm"
      />
    </td>
    <td v-else>{{ application.dbName || "" }}</td>

    <td v-if="editRow" class="text-center">
      <input
        v-model="editFormDbUser"
        type="text"
        class="form-control form-control-sm"
      />
    </td>
    <td v-else>{{ application.dbUser || "" }}</td>

    <td v-if="editRow" class="text-center">
      <input
        v-model="editFormDbPass"
        type="password"
        class="form-control form-control-sm"
      />
    </td>
    <td v-else>*******</td>

    <td v-if="editRow">
      <div class="btn-group">
        <button class="btn btn-sm btn-success" @click="saveEdits()">
          <i class="fa fa-save"></i>
        </button>
        <button
          class="btn btn-sm btn-success"
          @click="deleteApplication(application.id)"
        >
          <i class="fa fa-trash"></i>
        </button>
        <button class="btn btn-sm btn-success" @click="cancelEdits()">
          <i class="fa fa-close"></i>
        </button>
      </div>
    </td>
    <td v-else class="text-right">
      <i
        class="btn btn-success btn-sm fa fa-pencil"
        @click="editRow = true"
      ></i>
    </td>
  </tr>
</template>

<script>
import { appValidation } from './validator'

export default {
  name: 'ApplicationItem',
  props: ['application'],
  data: function () {
    return {
      editRow: false,
      formErrors: [],
      editFormAppKey: this.application.appKey,
      editFormDbHost: this.application.dbHost,
      editFormDbName: this.application.dbName,
      editFormDbUser: this.application.dbUser,
      editFormDbPass: ''

    }
  },

  methods: {
    deleteApplication (id) {
      if (confirm('Opravdu smazat?')) {
        this.$store.dispatch('deleteApplication', id);
      }
    },
    cancelEdits () {
      this.editRow = false;
      this.formErrors = [];
      this.editFormAppKey = this.application.appKey;
      this.editFormDbHost = this.application.dbHost;
      this.editFormDbName = this.application.dbName;
      this.editFormDbUser = this.application.dbUser;
      this.editFormDbPass = '';
    },
    async saveEdits () {
      const appData = {
        appKey: this.editFormAppKey,
        dbHost: this.editFormDbHost,
        dbName: this.editFormDbName,
        dbUser: this.editFormDbUser
      }
      if (this.editFormDbPass !== '') {
        appData.dbPass = this.editFormDbPass;
      }

      const formErrors = appValidation(appData);
      if (Object.keys(formErrors).length > 0) { // named indexes cannot use length
        this.formErrors = formErrors;
        return;
      }

      const success = await this.$store.dispatch('updateApplication', { id: this.application.id, data: appData });
      if (success) {
        this.editRow = false;
        /*
        this.editFormAppKey = '';
        this.editFormDbHost = '';
        this.editFormDbName = '';
        this.editFormDbUser = '';
        this.editFormDbPass = '';
        */
      }
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
